import React from "react";
import { Link } from "react-router-dom";
import "../footer/footer.css";
import facebook from "../../assets/facebook.webp";
import Instagram from "../../assets/insta.webp";
import x from "../../assets/x.webp";
import y from "../../assets/youtube.webp";
import Rs from "../../assets/Rs.webp";
import Rss from "../../assets/Rss.webp";
import T from "../../assets/T.webp";

const Footer = () => {
  return (
    <footer>
      <div className="container-footer">

        {/* ── TOP: Brand left + About right ── */}
        <div className="footer-top">
          <div className="footer-brand">
            <p className="footer-brand-name">AstroBhagya</p>
            <p className="footer-brand-tagline">Step into a world of answers</p>
            <p className="footer-brand-desc">
              India's most trusted astrology platform connecting you with
              verified experts for guidance in love, career, health & life.
            </p>
          </div>

          <div className="footer-about">
            <h3>About AstroBhagya</h3>
            <p>
              AstroBhagya is a vibrant community that connects you with a
              trusted network of renowned experts in astrology, numerology,
              vastu, and other spiritual practices. Our carefully curated list
              of practitioners is dedicated to meeting your unique needs,
              offering insightful and meaningful guidance.
            </p>
            <p>
              Whether you're looking for advice on career paths, educational
              goals, or personal relationships, our skilled astrologers are here
              to provide tailored solutions just for you. At AstroBhagya, we are
              committed to supporting you as you navigate life's complexities,
              empowering you with knowledge and direction every step of the way.
            </p>
          </div>
        </div>

        {/* ── DIVIDER ── */}
        <div className="footer-divider"></div>

        {/* ── BOTTOM GRID: 4 columns ── */}
        <div className="footer-grid">

          {/* Col 1 — Quick Links */}
          <div className="footer-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/blogs">Blogs</Link></li>
              <li><Link to="/yearly-horoscope">Horoscopes 2026</Link></li>
              <li><Link to="/chat-with-astrologer">Chat with Astrologer</Link></li>
              <li><Link to="/call-with-astrologer">Call with Astrologer</Link></li>
              <li><Link to="/account-deletion">Account Deletion</Link></li>
            </ul>
          </div>

          {/* Col 2 — Legal */}
          <div className="footer-col">
            <h4 className="footer-col-title">Legal Information</h4>
            <ul>
              <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/refund-policy">Refund Policy</Link></li>
            </ul>

            <h4 className="footer-col-title" style={{ marginTop: "28px" }}>Contact Info</h4>
            <ul>
              <li>
                <a href="mailto:business@astrobhagya.co.in">
                  business@astrobhagya.co.in
                </a>
              </li>
              <li>
                <a href="tel:+917300942165">+91 7300942165</a>
              </li>
            </ul>
          </div>

          {/* Col 3 — Secure */}
          {/* <div className="footer-col"> */}
          {/* Col 3 — Consult Problems */}
<div className="footer-col">
  <h4 className="footer-col-title">Consult for any Problem</h4>
  <ul>
    <li><Link to="/chat-with-astrologer">Job & Career</Link></li>
    <li><Link to="/chat-with-astrologer">Love & Relationship</Link></li>
    <li><Link to="/chat-with-astrologer">Marriage Problems</Link></li>
    <li><Link to="/chat-with-astrologer">Money & Finance</Link></li>
    <li><Link to="/chat-with-astrologer">Health Issues</Link></li>
    <li><Link to="/chat-with-astrologer">Education Guidance</Link></li>
    <li><Link to="/chat-with-astrologer">Business Problems</Link></li>
    <li><Link to="/chat-with-astrologer">Legal Matters</Link></li>
    <li><Link to="/chat-with-astrologer">Family Disputes</Link></li>
  </ul>
</div>

{/* Col 4 — Festivals */}
<div className="footer-col">
  <h4 className="footer-col-title">Free Festivals</h4>
  <ul>
    <li><Link to="/festival/january">January Festivals</Link></li>
    <li><Link to="/festival/february">February Festivals</Link></li>
    <li><Link to="/festival/march">March Festivals</Link></li>
    <li><Link to="/festival/april">April Festivals</Link></li>
    <li><Link to="/festival/may">May Festivals</Link></li>
    <li><Link to="/festival/june">June Festivals</Link></li>
    <li><Link to="/festival/july">July Festivals</Link></li>
    <li><Link to="/festival/august">August Festivals</Link></li>
    <li><Link to="/festival/september">September Festivals</Link></li>
    <li><Link to="/festival/october">October Festivals</Link></li>
    <li><Link to="/festival/november">November Festivals</Link></li>
    <li><Link to="/festival/december">December Festivals</Link></li>
  </ul>
</div>

{/* Col 5 — Secure */}
<div className="footer-col">
  <h4 className="footer-col-title">Secure</h4>
            <h4 className="footer-col-title">Secure</h4>
            <div className="footer-secure-list">
              <div className="footer-secure-item">
                <img src={Rss} alt="Refund Policy" />
                <span><b>Refund</b><small>Policy</small></span>
              </div>
              <div className="footer-secure-item">
                <img src={T} alt="Verified Astrologers" />
                <span><b>Verified Expert</b><small>Astrologers</small></span>
              </div>
              <div className="footer-secure-item">
                <img src={Rs} alt="Secure Payments" />
                <span><b>100% Secure</b><small>Payments</small></span>
              </div>
            </div>
          </div>

          {/* Col 4 — Social + Play */}
          <div className="footer-col">
            <h4 className="footer-col-title">Follow Us</h4>
            <div className="footer-social-row">
              <a href="https://www.facebook.com/profile.php?id=61566526904067"
                 target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <img src={facebook} alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/astrobhagya_official/"
                 target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <img src={Instagram} alt="Instagram" />
              </a>
              <a href="https://www.youtube.com/@AstroBhagya_Official"
                 target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <img src={y} alt="YouTube" />
              </a>
              <a href="https://x.com/Astro_Bhagya"
                 target="_blank" rel="noopener noreferrer" aria-label="X">
                <img src={x} alt="X" />
              </a>
            </div>

            {/* <h4 className="footer-col-title" style={{ marginTop: "28px" }}>Download App</h4> */}
            <a href="https://play.google.com/store/apps/details?id=com.astrobhagyap"
               target="_blank" rel="noopener noreferrer">
              <img
                src={require("../../assets/googleplay.png")}
                alt="Get it on Google Play"
                className="footer-play-btn"
              />
            </a>
          </div>

        </div>

        {/* ── BOTTOM BAR ── */}
        <div className="footer-bottom">
          <p>&copy; 2026 AstroBhagya. All rights reserved by JIFFY Software Solutions.</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;